import moment from 'moment';
import 'moment-timezone';

import { getTimezone } from '@/utils/time';

export default function (store) {
  store.subscribe((mutation) => {
    if (mutation.type === 'entities/users/validateTokenSuccess') {
      moment.tz.setDefault(getTimezone(mutation.payload));
    }

    if (mutation.type === 'setLocale') {
      moment.locale(mutation.payload);
    }
  });
}



// WEBPACK FOOTER //
// ./src/store/plugins/time.js